import { cn } from '@/lib/utils';

import { FEED_TRAY_CTA_CLASS } from './feedStyles';

import type { ComponentProps, ComponentType } from 'react';

type FeedTrayCtaProps = {
  icon?: ComponentType<{ className?: string }>;
  label: string;
  accessibleLabel: string;
} & Omit<ComponentProps<'button'>, 'children' | 'type'>;

export const FeedTrayCta = ({
  icon: Icon,
  label,
  accessibleLabel,
  className,
  ...buttonProps
}: FeedTrayCtaProps) => (
  <button
    {...buttonProps}
    type="button"
    aria-label={accessibleLabel}
    className={cn(FEED_TRAY_CTA_CLASS, className)}
  >
    {Icon ? <Icon className="size-[calc(12*var(--ac-u))]" /> : null}
    {label}
  </button>
);
